module.exports = __webpack_public_path__ + "img/BadenIstSchön.a479f7d4.svg";